<template>
  <div class="container flex-row">
    <div class="section image">
      <img @click="changeTo('accueil')" src="../../img/contact/logo.svg" alt="">
    </div>
    <div class="section texte">
      <h2 @click="changeTo('contact')" class="title-contact">Contact</h2>
      <div class="line-container flex-row"><div class="green-line"></div><div class="white-line"></div></div>
      <p>CYBERDINE CONSEIL</p>
      <p>Rue de l'Indre</p>
      <p>Quartier EURONANTES</p>
      <p>44000 NANTES</p>
      <p>contact@cyberdineconseil.fr</p>
    </div>
    <div class="section texte plan">
      <h2 class="title-contact pds">Plan du site</h2>
      <div class="line-container flex-row"><div class="green-line"></div><div class="white-line"></div></div>
      <p @click="changeTo('accueil')">Accueil</p>
      <p @click="changeTo('societe')">La société</p>
      <p @click="changeTo('domaine')">Domaines d'activité</p>
      <p @click="changeTo('assistance')">Services</p>
      <p @click="changeTo('contact')">Contact</p>
    </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {
        methods: {
            changeTo(pageName) {
                menuBus.$emit('changePage', pageName);
            },
        },
        mounted() {
            menuBus.$on('changePage', (pageName, idName) => {
                this.menuShowed = false;
            });
        }
    }
</script>

<style scoped>
  .container {
    height: 300px;
    width: 100%;

    background-color: #162139;

    padding-bottom: 50px;

    justify-content: space-evenly;
  }

  .section {
    max-width: 500px;
    width: 30%;
    min-width: 350px;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: nowrap;
    flex-direction: column;
  }
  .section.image {
    align-items: center;
  }
  .section.texte > *, .section.form > * {
    margin-left: 30px;
    margin-right: 30px;
  }

  img {
    width: 80%;
    opacity: 1;
    cursor: pointer;
  }

  .section h2 {
    color: white;
    text-transform: uppercase;
    font-size: 26px;
    font-weight: bold;
    text-align: left;
  }
  .section p, label {
    margin-top: 2px;
    margin-bottom: 0;
    color: #9fa8bd;
    opacity: 0.5;
    font-size: 20px;
    text-align: left;
  }
  .section a {
    text-decoration: none;
  }

  input {
    background-color: #162139;
    border: 2px solid #9fa8bd;
    margin-top: 10px;
    margin-bottom: 5px;
    height: 30px;
    opacity: 1;
    width: calc(100% - 80px);
    color: white;
  }
  input:focus {
    outline: none;
  }

  button {
    border: none;
    background-color: #b7e17e;
    color: white;
    padding: 10px 30px;
    margin-top: 20px;
    text-transform: uppercase;
    cursor: pointer;
    font-size: 18px;
  }
  .space {
    height: 40px;
  }

  .line-container {
    width: calc(100% - 60px);
    height: 3px;
    margin-bottom: 20px;
  }
  .line-container .green-line {
    width: 40%;
    height: 100%;
    background-color: #b7e17e;
  }
  .line-container .white-line {
    width: 60%;
    height: 100%;
    background-color: white;
  }

  .title-contact {
    cursor: pointer;
  }

  .plan {
    cursor: pointer;
  }

  .plan p:hover {
    color: #b7e17e;
    opacity: 1;
  }

  /* Mobile */
  @media (max-width: 1050px) {
    .container {
      flex-direction: column;
      height: auto;
    }
    .section {
      width: 100%;
      max-width: initial;
      min-width: initial;
    }
    .section.image {
      max-height: 200px;
      margin-top: 20px;
    }
    .section.texte, .section.form {
      margin-top: 40px;
      width: calc(100% - 40px);
    }
    .space {
      display: none;
    }

    .texte h2 {
      margin-bottom: 0;
    }

    .line-container {
      margin: 20px 0;
    }

    button {
      margin: 30px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Contact.vue